import { CernerSlotProvider } from './cernerSlotProvider';
import {
  DefaultTestProviderLocations,
  LocationSummary,
} from './locationSummary';
import {
  DefaultTestAvailableAppointmentSlots,
  SlotDateGroup,
} from './slotDateGroup';

export interface ProviderSummary {
  daysUntilNextAppt?: string;
  provider?: CernerSlotProvider;
  providerLocations?: LocationSummary[];
  availableAppointmentSlots?: SlotDateGroup[];
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestAlternateProviders: ProviderSummary[] = new Array(4)
  .fill(undefined)
  .map((item, index) => ({
    daysUntilNextAppt: '3',
    provider: {
      id: `pid${index}`,
      name: `Provider Name ${index}`,
      providerNumber: `${index}`,
    },
    providerLocations: DefaultTestProviderLocations,
    availableAppointmentSlots: DefaultTestAvailableAppointmentSlots,
  }));
